const actionsTypes = {
  SCHEMA: {
    ERROR: "SCHEMA.ERROR",
    LOAD: "SCHEMA.LOAD",
    UPDATE: "SCHEMA.UPDATE",
  },
  FORM: {
    CLEAN: "FORM.CLEAN",
    CLEAR: "FORM.CLEAR",
    MOVE_NEXT: "FORM.MOVE_NEXT",
    MOVE_BACK: "FORM.MOVE_BACK",
    SUBMIT: "FORM.SUBMIT",
    UPDATE: {
      INPUT: "FORM.UPDATE.INPUT",
      STEP: "FORM.UPDATE.STEP",
    },
    VALIDATE: "FORM.VALIDATE",
    VALIDATE_ELEMENT: "FORM.VALIDATE_ELEMENT",
    VALIDATE_ELEMENT_FAIL: "FORM.VALIDATE_ELEMENT_FAIL",
    VALIDATE_ELEMENT_SUCCESS: "FORM.VALIDATE_ELEMENT_SUCCESS",
    VALIDATE_FAIL: "FORM.VALIDATE_FAIL",
  },
};

export default actionsTypes;
